module.exports = __webpack_public_path__ + "static/img/indexPic10.84c7178.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic10.png
// module id = DgF5
// module chunks = 1